var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"wrapper"},[_c('layout-grid'),(_vm.isAuthenticated && !_vm.hasAppAccess)?_c('no-access'):_c('router-view'),_c('error-dialog',{attrs:{"room-name-prop":_vm.roomName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }